// Comprehensive Programs Database for Patrick's Edu Care
// Hierarchy: Program -> Country -> University

export const programs = [
  {
    slug: 'mbbs',
    name: 'MBBS',
    fullName: 'Bachelor of Medicine, Bachelor of Surgery',
    icon: 'Stethoscope',
    color: '#E63946',
    tagline: 'Become a globally recognized medical doctor at a fraction of Indian private college fees',
    shortDescription: 'Pursue MBBS in WHO & NMC-recognized universities across Europe and CIS with English-medium curriculum.',
    longDescription: 'MBBS abroad is a popular choice for Indian students seeking quality medical education at affordable tuition fees. Patrick\'s Edu Care has partnered with top universities across Georgia, Moldova, Bulgaria, Uzbekistan and Kyrgyzstan that are recognized by the World Health Organization (WHO), National Medical Commission of India (NMC), and FAIMER. Students benefit from English-medium teaching, international exposure, hospital-based clinical training, and eligibility for FMGE/NEXT licensing exams.',
    image: '/img/stock/1576091160399-112ba8d25d1d.webp',
    duration: '5.5–7 years',
    averageFee: '$3,200 – $10,000 / year',
    medium: 'English',
    highlights: [
      'WHO, NMC & FAIMER recognized universities',
      'No donation, no entrance exam',
      'NEET qualified students eligible',
      'Indian food & hostel facilities',
      'FMGE / NExT preparation support'
    ],
    seo: {
      title: 'Study MBBS Abroad 2026 | Low Fees | NMC Approved | Patrick\'s Edu Care',
      description: 'Pursue MBBS abroad in NMC-approved universities in Georgia, Moldova, Bulgaria, Uzbekistan & Kyrgyzstan. English medium, low tuition, hostel facilities. Apply with Patrick\'s Edu Care.',
      keywords: 'MBBS abroad, MBBS in Georgia, MBBS in Moldova, MBBS in Bulgaria, MBBS in Uzbekistan, MBBS in Kyrgyzstan, NMC approved MBBS, study MBBS, MBBS for Indian students'
    },
    countries: [
      {
        slug: 'georgia',
        name: 'Georgia',
        flag: '🇬🇪',
        capital: 'Tbilisi',
        currency: 'USD / GEL',
        about: 'Georgia is the #1 preferred destination for Indian medical aspirants. Universities here are recognized by WHO and NMC India, with English-medium curriculum, affordable living costs and a thriving Indian student community.',
        usp: [
          '💵 $5,500–8,000/yr',
          '🩺 6 yrs',
          '🇮🇳 NMC + WHO',
          '📚 50% PCB + NEET'
        ],
        livingCost: '$200 – $350 / month',
        whyStudy: [
          'NMC & WHO recognized degree',
          'Visa approval rate above 95%',
          'Safe country with low cost of living',
          'Indian student community of 8,000+'
        ],
        universities: [
          {
            slug: 'caucasus-university',
            name: 'Caucasus University',
            location: 'Tbilisi, Georgia',
            established: 2004,
            ranking: 'Top-tier private university',
            tuitionFee: '$6,000 / year',
            totalCost: '$36,000 (6 years)',
            duration: '6 years',
            medium: 'English',
            intake: 'September & February',
            recognition: ['WHO', 'NMC India', 'FAIMER', 'ECFMG'],
            eligibility: ['12th with PCB minimum 50%', 'NEET qualified', 'Age 17+'],
            accommodation: '$150 – $250 / month',
            highlights: ['Patrick\'s Edu Care official representative', 'Strong Indian student community', 'Modern campus & hospital tie-ups']
          },
          {
            slug: 'university-of-georgia',
            name: 'University of Georgia (UG)',
            location: 'Tbilisi, Georgia',
            established: 2004,
            ranking: 'Top 3 private university',
            tuitionFee: '$6,500 / year',
            totalCost: '$39,000 (6 years)',
            duration: '6 years',
            medium: 'English',
            intake: 'September & February',
            recognition: ['WHO', 'NMC India', 'FAIMER'],
            eligibility: ['12th with PCB minimum 50%', 'NEET qualified'],
            accommodation: '$150 – $250 / month',
            highlights: ['Modern infrastructure', 'Hospital-based clinical training', 'Strong placement record']
          },
          {
            slug: 'tbilisi-state-medical-university',
            name: 'Tbilisi State Medical University (TSMU)',
            location: 'Tbilisi, Georgia',
            established: 1918,
            ranking: '#1 Medical University in Georgia',
            tuitionFee: '$8,000 / year',
            totalCost: '$48,000 (6 years)',
            duration: '6 years',
            medium: 'English',
            intake: 'September',
            recognition: ['WHO', 'NMC India', 'FAIMER', 'ECFMG'],
            eligibility: ['12th with PCB minimum 50%', 'NEET qualified', 'Age 17+'],
            accommodation: '$200 – $300 / month',
            highlights: ['Oldest medical university in the region', 'Strong research output', 'USMLE-aligned curriculum']
          },
          {
            slug: 'caucasus-international-university',
            name: 'Caucasus International University (CIU)',
            location: 'Tbilisi, Georgia',
            established: 1995,
            ranking: 'Top 5 in Georgia',
            tuitionFee: '$5,500 / year',
            totalCost: '$33,000 (6 years)',
            duration: '6 years',
            medium: 'English',
            intake: 'September & February',
            recognition: ['WHO', 'NMC India', 'FAIMER', 'ECFMG'],
            eligibility: ['12th with PCB minimum 50%', 'NEET qualified', 'Age 17+'],
            accommodation: '$150 – $250 / month',
            highlights: ['Hospital-attached clinical training', 'Modern simulation labs', 'Indian mess available']
          },
          {
            slug: 'alte-university',
            name: 'Alte University',
            location: 'Tbilisi, Georgia',
            established: 1992,
            ranking: 'Recognised private medical university',
            tuitionFee: '$5,950 / year',
            totalCost: '$35,700 (6 years)',
            duration: '6 years',
            medium: 'English',
            intake: 'September & February',
            recognition: ['WHO', 'NMC India', 'FAIMER'],
            eligibility: ['12th with PCB minimum 50%', 'NEET qualified'],
            accommodation: '$150 – $250 / month',
            highlights: ['Affordable English-medium MBBS', 'Modern teaching hospital', 'Strong support for Indian students']
          },
          {
            slug: 'georgian-national-university-seu',
            name: 'Georgian National University SEU',
            location: 'Tbilisi, Georgia',
            established: 2001,
            ranking: 'Top private university in Georgia',
            tuitionFee: '$6,300 / year',
            totalCost: '$37,800 (6 years)',
            duration: '6 years',
            medium: 'English',
            intake: 'September & February',
            recognition: ['WHO', 'NMC India', 'FAIMER', 'ECFMG'],
            eligibility: ['12th with PCB minimum 50%', 'NEET qualified'],
            accommodation: '$150 – $250 / month',
            highlights: ['Modern campus in Tbilisi', 'Hospital partnerships for clinical rotations', 'Active Indian student association']
          }
        ]
      },
      {
        slug: 'moldova',
        name: 'Moldova',
        flag: '🇲🇩',
        capital: 'Chișinău',
        currency: 'EUR / MDL',
        about: 'Moldova offers one of the most affordable European MBBS programs. Patrick\'s Edu Care is the official representative for Nicolae Testemițanu State University of Medicine and Pharmacy — the country\'s premier medical school.',
        usp: [
          '💵 €6,000/yr',
          '🩺 6 + 1 yr internship',
          '🇪🇺 EU degree',
          '📚 60% + NEET · age ≤27'
        ],
        livingCost: '$180 – $300 / month',
        whyStudy: [
          'Lowest tuition fees in Europe',
          'European degree, globally accepted',
          'Direct admission without entrance exam',
          'Strong Indian community'
        ],
        universities: [
          {
            slug: 'nicolae-testemitanu',
            name: 'Nicolae Testemițanu State University of Medicine and Pharmacy',
            location: 'Chișinău, Moldova',
            established: 1945,
            ranking: '#1 Medical University in Moldova',
            tuitionFee: '€6,000 / year',
            totalCost: '€42,000 (6 years + 1 year internship)',
            duration: '7 years (6 + 1 internship)',
            medium: 'English & Romanian',
            intake: 'September',
            recognition: ['WHO', 'NMC India', 'FAIMER', 'European Higher Education Area'],
            eligibility: ['12th with PCB minimum 60%', 'Maximum age 27', 'NEET qualified'],
            accommodation: '$80 – $150 / month',
            highlights: ['Patrick\'s Edu Care is the official Indian representative', 'Affordable European MBBS with EU-recognised degree', 'Includes a mandatory 1-year clinical internship']
          }
        ]
      },
      {
        slug: 'uzbekistan',
        name: 'Uzbekistan',
        flag: '🇺🇿',
        capital: 'Tashkent',
        currency: 'USD',
        about: 'Uzbekistan offers some of the lowest-cost MBBS programs in the world with English-medium teaching and growing recognition. A safe, central-Asian destination with a fast-growing Indian student base.',
        usp: [
          '💵 $3,200–3,500/yr 💎',
          '🩺 6 yrs',
          '🇮🇳 NMC + WHO',
          '📚 50% PCB + NEET'
        ],
        livingCost: '$100 – $200 / month',
        whyStudy: [
          'Very low tuition fees',
          'NMC & WHO approved universities',
          'Indian food easily available',
          'Quick visa processing'
        ],
        universities: [
          {
            slug: 'tashkent-state-medical-university',
            name: 'Tashkent State Medical University',
            location: 'Tashkent, Uzbekistan',
            established: 1919,
            ranking: '#1 Medical University in Uzbekistan',
            tuitionFee: '$3,500 / year',
            totalCost: '$21,000 (6 years)',
            duration: '6 years',
            medium: 'English',
            intake: 'September',
            recognition: ['WHO', 'NMC India', 'FAIMER'],
            eligibility: ['12th with PCB minimum 50%', 'NEET qualified'],
            accommodation: '$60 – $120 / month',
            highlights: ['Capital-city campus', 'Strong clinical exposure', 'Affordable living costs']
          },
          {
            slug: 'samarkand-state-medical-university',
            name: 'Samarkand State Medical University',
            location: 'Samarkand, Uzbekistan',
            established: 1930,
            ranking: 'Top 5 in Uzbekistan',
            tuitionFee: '$3,500 / year',
            totalCost: '$21,000 (6 years)',
            duration: '6 years',
            medium: 'English',
            intake: 'September',
            recognition: ['WHO', 'NMC India', 'FAIMER'],
            eligibility: ['12th with PCB minimum 50%', 'NEET qualified'],
            accommodation: '$60 – $120 / month',
            highlights: ['Historic city of Samarkand', 'Very low cost of living', 'Indian mess on campus']
          },
          {
            slug: 'bukhara-state-medical-university',
            name: 'Bukhara State Medical University',
            location: 'Bukhara, Uzbekistan',
            established: 1990,
            ranking: 'Recognised state medical university',
            tuitionFee: '$3,200 / year',
            totalCost: '$19,200 (6 years)',
            duration: '6 years',
            medium: 'English',
            intake: 'September',
            recognition: ['WHO', 'NMC India', 'FAIMER'],
            eligibility: ['12th with PCB minimum 50%', 'NEET qualified'],
            accommodation: '$60 – $120 / month',
            highlights: ['One of the lowest tuition fees globally', 'Active partnership with Patrick\'s Edu Care', 'Indian-friendly campus']
          }
        ]
      },
      {
        slug: 'kyrgyzstan',
        name: 'Kyrgyzstan',
        flag: '🇰🇬',
        capital: 'Bishkek',
        currency: 'USD / KGS',
        about: 'Kyrgyzstan is a rising destination for affordable MBBS with NMC-approved English-medium programs and direct admissions without donations.',
        usp: [
          '💵 $4,000/yr',
          '🩺 5.5 yrs ⚡',
          '🇮🇳 NMC + WHO',
          '📚 50% PCB + NEET'
        ],
        livingCost: '$120 – $200 / month',
        whyStudy: [
          'Affordable tuition & living costs',
          'NMC & WHO approved degree',
          'Short MBBS duration (5.5 years)',
          'Quick visa processing'
        ],
        universities: [
          {
            slug: 'international-medical-university-bishkek',
            name: 'International Medical University (IMU)',
            location: 'Bishkek, Kyrgyzstan',
            established: 2003,
            ranking: 'Leading private medical university',
            tuitionFee: '$4,000 / year',
            totalCost: '$22,000 (5.5 years)',
            duration: '5.5 years',
            medium: 'English',
            intake: 'September',
            recognition: ['WHO', 'NMC India', 'FAIMER'],
            eligibility: ['12th with PCB minimum 50%', 'NEET qualified'],
            accommodation: '$70 – $130 / month',
            highlights: ['Shorter MBBS — 5.5 years total', 'Strong Patrick\'s Edu Care partnership (Dr. Takhmina visit)', 'Direct clinical exposure']
          }
        ]
      },
      {
        slug: 'bulgaria',
        name: 'Bulgaria',
        flag: '🇧🇬',
        capital: 'Sofia',
        currency: 'EUR / BGN',
        about: 'Bulgaria offers EU-standard medical education with English-medium programs at top public universities. Schengen visa unlocks EU-wide travel and clinical exposure.',
        usp: [
          '💵 €9,000–10,000/yr',
          '🩺 6 yrs',
          '🇪🇺 EU + Schengen',
          '🪦 Cadaver labs',
          '📚 62% + NEET'
        ],
        livingCost: '€250 – €400 / month',
        whyStudy: [
          'EU-recognized medical degree',
          'High-quality clinical training with cadaver dissection',
          'Schengen visa enables EU-wide travel',
          'Globally accepted curriculum'
        ],
        universities: [
          {
            slug: 'medical-university-pleven',
            name: 'Medical University of Pleven',
            location: 'Pleven, Bulgaria',
            established: 1974,
            ranking: 'Top 3 in Bulgaria',
            tuitionFee: '€9,000 / year',
            totalCost: '€54,000 (6 years)',
            duration: '6 years',
            medium: 'English',
            intake: 'September',
            recognition: ['WHO', 'NMC India', 'FAIMER', 'EU'],
            eligibility: ['12th with PCB minimum 62%', 'NEET qualified', 'University entrance test'],
            accommodation: '₹25,000 – ₹30,000 / month',
            highlights: ['Cadaver-based dissection training', 'Strong telemedicine reputation', 'Patrick\'s Edu Care BSc Nursing partner too']
          },
          {
            slug: 'medical-university-plovdiv',
            name: 'Medical University of Plovdiv',
            location: 'Plovdiv, Bulgaria',
            established: 1945,
            ranking: 'Top 4 medical university in Bulgaria',
            tuitionFee: '€10,000 / year',
            totalCost: '€60,000 (6 years)',
            duration: '6 years',
            medium: 'English',
            intake: 'September',
            recognition: ['WHO', 'NMC India', 'FAIMER', 'EU'],
            eligibility: ['12th with PCB minimum 62%', 'NEET qualified', 'University entrance test'],
            accommodation: '₹30,000 – ₹35,000 / month',
            highlights: ['Cadaver dissection labs', 'Modern teaching hospital', 'Multinational student body']
          },
          {
            slug: 'medical-university-varna',
            name: 'Medical University of Varna',
            location: 'Varna, Bulgaria',
            established: 1961,
            ranking: 'Top 3 medical university in Bulgaria',
            tuitionFee: '€10,000 / year',
            totalCost: '€60,000 (6 years)',
            duration: '6 years',
            medium: 'English',
            intake: 'September',
            recognition: ['WHO', 'NMC India', 'FAIMER', 'EU'],
            eligibility: ['12th with PCB minimum 62%', 'NEET qualified', 'University entrance test'],
            accommodation: '₹30,000 – ₹35,000 / month',
            highlights: ['Coastal Black-Sea campus', 'Cadaver dissection training', 'Strong research output']
          },
          {
            slug: 'medical-university-sofia',
            name: 'Medical University of Sofia',
            location: 'Sofia, Bulgaria',
            established: 1917,
            ranking: '#1 Medical University in Bulgaria',
            tuitionFee: '€10,000 / year',
            totalCost: '€60,000 (6 years)',
            duration: '6 years',
            medium: 'English',
            intake: 'September',
            recognition: ['WHO', 'NMC India', 'FAIMER', 'EU'],
            eligibility: ['12th with PCB minimum 62%', 'NEET qualified', 'University entrance test'],
            accommodation: '₹30,000 – ₹35,000 / month',
            highlights: ['Oldest medical school in Bulgaria', 'Research-focused', 'EU-level clinical exposure with cadaver labs']
          }
        ]
      }
    ]
  },

  {
    slug: 'bsc-nursing',
    name: 'BSc Nursing',
    fullName: 'Bachelor of Science in Nursing',
    icon: 'HeartPulse',
    color: '#06A77D',
    tagline: 'Launch a high-demand global nursing career with European clinical training',
    shortDescription: 'Become a registered nurse with internationally recognized BSc Nursing degrees from Georgia, Bulgaria, Malta, Albania, Poland, Lithuania & Austria.',
    longDescription: 'BSc Nursing abroad opens doors to high-paying careers in the US, UK, Germany, EU and Gulf countries. Patrick\'s Edu Care places students in carefully selected European and Caucasus universities offering English-medium nursing programs with hands-on hospital training. Our flagship "Nursing in Georgia" track is led personally by Dr. Patrick, and we additionally represent universities across the EU — Malta, Poland, Lithuania, Austria — and Bulgaria & Albania for pathway-to-EU nursing careers.',
    image: '/img/stock/1584516150909-c43483ee7932.webp',
    duration: '3–4 years',
    averageFee: '$3,300 – €8,000 / year',
    medium: 'English',
    highlights: [
      'Internationally recognized BSc Nursing degree',
      'Pathway to Germany, UK, Gulf & EU nursing jobs',
      'Hospital-based clinical training',
      'IELTS support included',
      'Patrick\'s Edu Care flagship program'
    ],
    seo: {
      title: 'BSc Nursing Abroad 2026 | Study Nursing in Georgia, Bulgaria, Malta, Albania, Poland, Lithuania & Austria | Patrick\'s Edu Care',
      description: 'Pursue BSc Nursing abroad with English-medium programs across Georgia, Bulgaria, Malta, Albania, Poland, Lithuania & Austria. Low fees, global recognition, job-ready curriculum. Apply with Patrick\'s Edu Care.',
      keywords: 'BSc Nursing abroad, nursing in Georgia, nursing in Bulgaria, nursing in Malta, nursing in Albania, nursing in Poland, nursing in Lithuania, nursing in Austria, study nursing'
    },
    countries: [
      {
        slug: 'georgia',
        name: 'Georgia',
        flag: '🇬🇪',
        capital: 'Tbilisi',
        currency: 'USD / GEL',
        about: 'Georgia is the flagship destination for Patrick\'s Edu Care\'s nursing program. We are official representatives for top Georgian universities offering English-medium BSc Nursing with affordable fees and direct admission.',
        usp: [
          '💵 $3,300–4,000/yr',
          '🎓 4 yrs',
          '🌍 EU credits',
          '📚 50% direct'
        ],
        livingCost: '$200 – $350 / month',
        whyStudy: [
          'English-medium BSc Nursing',
          'Direct admission, no entrance exam',
          'Affordable tuition & living costs',
          'Pathway to EU & Gulf nursing careers'
        ],
        universities: [
          {
            slug: 'university-of-georgia-nursing',
            name: 'University of Georgia (UG)',
            location: 'Tbilisi, Georgia',
            established: 2004,
            ranking: 'Top 3 private university',
            tuitionFee: '$4,000 / year',
            totalCost: '$16,000 (4 years)',
            duration: '4 years',
            medium: 'English',
            intake: 'September & February',
            recognition: ['Ministry of Education Georgia', 'WHO', 'EU credit system'],
            eligibility: ['12th pass with 50%+', 'Basic English proficiency'],
            accommodation: '$150 – $250 / month',
            highlights: ['Strong placement record', 'International faculty', 'Modern campus']
          },
          {
            slug: 'caucasus-international-university-nursing',
            name: 'Caucasus International University (CIU)',
            location: 'Tbilisi, Georgia',
            established: 1995,
            ranking: 'Top 5 in Georgia',
            tuitionFee: '$3,300 / year',
            totalCost: '$13,200 (4 years)',
            duration: '4 years',
            medium: 'English',
            intake: 'September & February',
            recognition: ['Ministry of Education Georgia', 'WHO', 'EU credit system'],
            eligibility: ['12th pass with 50%+', 'Basic English proficiency'],
            accommodation: '$150 – $250 / month',
            highlights: ['Patrick\'s Edu Care official representative', 'Modern simulation labs', 'Hospital-based clinical practice']
          },
          {
            slug: 'georgian-national-university-seu-nursing',
            name: 'Georgian National University (SEU)',
            location: 'Tbilisi, Georgia',
            established: 2001,
            ranking: 'Top private university in Georgia',
            tuitionFee: '$3,500 / year + $400 lab fees ($3,900 total)',
            totalCost: '$15,600 (4 years)',
            duration: '4 years',
            medium: 'English',
            intake: 'September & February',
            recognition: ['Ministry of Education Georgia', 'WHO', 'EU credit system'],
            eligibility: ['12th pass with 50%+', 'Basic English proficiency'],
            accommodation: '$150 – $250 / month',
            highlights: ['Modern campus in Tbilisi', 'Affordable nursing program', 'Active Indian student community']
          },
          {
            slug: 'grigol-robakidze-university-nursing',
            name: 'Grigol Robakidze University (GRUNI)',
            location: 'Tbilisi, Georgia',
            established: 1995,
            ranking: 'Reputed private university',
            tuitionFee: '$3,800 / year',
            totalCost: '$15,200 (4 years)',
            duration: '4 years',
            medium: 'English',
            intake: 'September & February',
            recognition: ['Ministry of Education Georgia', 'WHO', 'EU credit system'],
            eligibility: ['12th pass with 50%+', 'Basic English proficiency'],
            accommodation: '$150 – $250 / month',
            highlights: ['Strong academic legacy', 'English-medium nursing curriculum', 'Tbilisi central campus']
          }
        ]
      },
      {
        slug: 'bulgaria',
        name: 'Bulgaria',
        flag: '🇧🇬',
        capital: 'Sofia',
        currency: 'EUR / BGN',
        about: 'Bulgaria is one of the best EU destinations for BSc Nursing — Schengen visa, EU-recognised degree, 20 hours/week part-time work allowed during studies, and an 11-month post-study stay-back. Ideal pathway into the European nursing job market.',
        usp: [
          '💵 €3,500–5,000/yr',
          '🎓 4 yrs',
          '🇪🇺 EU + Schengen',
          '⏱️ 11-mo stay-back',
          '💼 20 hrs/wk part-time'
        ],
        livingCost: '€250 – €400 / month',
        whyStudy: [
          'EU-recognised nursing degree',
          'Schengen visa benefits',
          '20 hours / week part-time work allowed',
          '11-month post-study stay-back option',
          'Best-in-Europe nursing career pathway'
        ],
        universities: [
          {
            slug: 'medical-university-sofia-nursing',
            name: 'Medical University of Sofia',
            location: 'Sofia, Bulgaria',
            established: 1917,
            ranking: '#1 Medical University in Bulgaria',
            tuitionFee: '€5,000 / year',
            totalCost: '€20,000 (4 years)',
            duration: '4 years',
            medium: 'English',
            intake: 'September',
            recognition: ['EU', 'WHO', 'Ministry of Education Bulgaria', 'Schengen'],
            eligibility: ['12th pass with 62%+', 'IELTS preferred'],
            accommodation: '€150 – €250 / month',
            highlights: ['Oldest medical school in Bulgaria', 'Schengen visa benefits', '20 hrs/week part-time work + 11-month stay-back']
          },
          {
            slug: 'medical-university-pleven-nursing',
            name: 'Medical University of Pleven',
            location: 'Pleven, Bulgaria',
            established: 1974,
            ranking: 'Top 3 in Bulgaria',
            tuitionFee: '€3,500 / year + €2,000 (4-month Bulgarian language preparatory before February intake — one-time, compulsory)',
            totalCost: '€16,000 (4 years incl. €2,000 preparatory)',
            duration: '4 years (+ 4-month preparatory before start)',
            medium: 'English (with compulsory 4-month pre-intake Bulgarian language preparatory)',
            intake: 'February only',
            recognition: ['EU', 'WHO', 'Ministry of Education Bulgaria', 'Schengen'],
            eligibility: ['12th pass with 62%+', 'IELTS preferred'],
            accommodation: '€150 – €250 / month',
            highlights: ['4-month Bulgarian language prep just before the Feb intake — €2,000 one-time fee', 'Schengen + 11-month stay-back', '20 hrs/week part-time work allowed']
          },
          {
            slug: 'medical-university-plovdiv-nursing',
            name: 'Medical University of Plovdiv',
            location: 'Plovdiv, Bulgaria',
            established: 1945,
            ranking: 'Top 4 medical university in Bulgaria',
            tuitionFee: '€4,500 / year',
            totalCost: '€18,000 (4 years)',
            duration: '4 years',
            medium: 'English',
            intake: 'September only',
            recognition: ['EU', 'WHO', 'Ministry of Education Bulgaria', 'Schengen'],
            eligibility: ['12th pass with 62%+', 'IELTS preferred'],
            accommodation: '€150 – €250 / month',
            highlights: ['Modern teaching hospital', 'Schengen visa + EU travel benefits', '20 hrs/week part-time + 11-month stay-back']
          }
        ]
      },
      {
        slug: 'malta',
        name: 'Malta',
        flag: '🇲🇹',
        capital: 'Valletta',
        currency: 'EUR',
        about: 'Malta — an English-speaking EU island nation — offers globally recognized BSc Nursing degrees with strong pathways into UK & EU nursing careers. Both MCAST and Idea College are MQF-recognised and lead to State Registered Nurse status under the Maltese Code of Ethics for Nurses & Midwives.',
        usp: [
          '💵 €19,500 total',
          '🎓 3 – 3.5 yrs',
          '🇬🇧 English country',
          '🛡️ State Reg Nurse pathway'
        ],
        livingCost: '€600 – €900 / month',
        whyStudy: [
          'English is an official language of Malta',
          'EU & UK-recognised BSc Honours nursing degree',
          'Schengen visa benefits + EU work pathway',
          'State Registered Nurse on graduation',
          'Scholarship & exemption options (MCAST)'
        ],
        universities: [
          {
            slug: 'mcast-malta-nursing',
            name: 'MCAST — Malta College of Arts, Science and Technology',
            location: 'Paola, Malta',
            established: 2001,
            ranking: 'Malta\'s leading public vocational college',
            tuitionFee: '€19,500 total (paid in 5 installments) · €6,500 scholarship available*',
            totalCost: '€19,500 tuition + €1,000 admin + €150 visa appt',
            duration: '3–4 years (Bachelor\'s)',
            medium: 'English',
            intake: 'September & February',
            recognition: ['MQF', 'EU', 'WHO', 'UK NMC pathway', 'Schengen'],
            eligibility: ['Grade 12 pass', '60% in English from Grade 12 or MOI from last qualification', 'Health screening + Police clearance certificate'],
            accommodation: '€350 – €550 / month',
            highlights: [
              'Installment plan: €4,250 + €150 visa + €1,000 admin before visa · then €2,250 Feb · €4,250 Sept · €2,250 Feb · €6,500 scholarship*',
              'MCAST students on 3–4 year bachelor\'s — final-year tuition exempted if all modules cleared without repeats',
              'State Registered Nurse on graduation under Maltese Code of Ethics for Nurses & Midwives'
            ]
          },
          {
            slug: 'idea-college-malta-nursing',
            name: 'Idea College — BSc (Hons) in Nursing Science',
            location: 'Malta',
            established: null,
            ranking: 'MQF Level 6 — Bachelor\'s Honours',
            tuitionFee: '€6,500 / year (Yr1 + Yr2 + Yr3) — €19,500 total',
            totalCost: '€19,500 tuition + €150 application + €500 admin + €150 visa',
            duration: '42 months (3.5 years)',
            medium: 'English',
            intake: 'September & February',
            recognition: ['MQF Level 6', 'EU', 'WHO', 'UK NMC pathway', 'Schengen'],
            eligibility: [
              'Grade 12 Pass with Biology OR Chemistry OR Health & Social Care',
              'OR Grade 12 with 3 subjects from: Physics, Sociology, Psychology, Mathematics, English',
              'IELTS Academic 6.0 OR OET (B in Speaking, C+ in other modules) — before course completion',
              'Police Clearance Certificate at enrolment'
            ],
            accommodation: '€350 – €550 / month',
            highlights: [
              'BSc Honours — MQF Level 6 degree',
              '42-month accelerated program',
              'Application €150 · Admin €500 · Visa €150 — transparent up-front',
              'Pathway to State Registered Nurse in Malta'
            ]
          }
        ]
      },
      {
        slug: 'albania',
        name: 'Albania',
        flag: '🇦🇱',
        capital: 'Tirana',
        currency: 'EUR / ALL',
        about: 'Albania offers affordable European BSc Nursing programs with English-medium teaching, low living costs and a rapidly improving healthcare education sector — an excellent pathway into EU nursing careers.',
        usp: [
          '💵 €9,000–11,750 total 💎',
          '🎓 3 yrs ⚡',
          '💳 Start with just €1,000',
          '📚 65–66% in 12th'
        ],
        livingCost: '€250 – €400 / month',
        whyStudy: [
          'Affordable European degree',
          'English-medium programs',
          'Visa-friendly country for Indian students',
          'EU integration pathway',
          'Low cost of living'
        ],
        universities: [
          {
            slug: 'mediterranean-university-of-albania-nursing',
            name: 'Mediterranean University of Albania — Bachelor in Nursing',
            location: 'Tirana, Albania',
            established: 2006,
            ranking: 'Top private university in Albania',
            tuitionFee: '€3,000 / year × 3 years (Year 1 payable in 3 installments — initial €1,000)',
            totalCost: '€9,000 tuition + €100 application + €1,000 admin (incl. insurance)',
            duration: '3 years',
            medium: 'English',
            intake: 'September & February',
            recognition: ['Ministry of Education Albania', 'EU integration pathway', 'WHO'],
            eligibility: ['66%+ in 12th OR aggregate of 10th, 11th & 12th at 70%+', 'Basic English'],
            accommodation: '€270 – €300 / month (with 2 meals)',
            highlights: [
              'Year-1 fees can be split into 3 installments — start with just €1,000',
              'Administration Fee €1,000 (includes insurance)',
              'Application Fee €100',
              'Direct admission, no entrance test'
            ]
          },
          {
            slug: 'european-university-of-tirana-nursing',
            name: 'European University of Tirana (UET) — Bachelor in Nursing',
            location: 'Tirana, Albania',
            established: 2006,
            ranking: 'Leading private university in Albania',
            tuitionFee: 'Year 1: €3,750 (initially pay €1,000) · Year 2: €4,000 · Year 3: €4,000',
            totalCost: '€11,750 tuition (3 years) + €300 TRC (after visa)',
            duration: '3 years',
            medium: 'English',
            intake: 'September & February',
            recognition: ['Ministry of Education Albania', 'EU integration pathway', 'WHO'],
            eligibility: ['65%+ in 12th', 'University interview (introduction / basic info)', 'Recorded video interview'],
            accommodation: '€80 / month (2-sharing, 6 months advance + 1-year contract signed from India)',
            highlights: [
              'No application fee · No administration fee OTC',
              'Year-1 starts with just €1,000 payment',
              'Self-cooking option keeps food cost €50–80/month',
              'TRC charges €300 (after visa, paid in Albania)'
            ]
          }
        ]
      },
      {
        slug: 'poland',
        name: 'Poland',
        flag: '🇵🇱',
        capital: 'Warsaw',
        currency: 'EUR / PLN',
        about: 'Poland is a top EU destination for BSc Nursing with English-medium programs, Schengen visa benefits, and direct pathways into the EU job market. WSEI University offers a 3-year nursing program at both Lublin and Warsaw campuses.',
        usp: [
          '💵 €3,900–4,500/yr',
          '🎓 3 yrs',
          '🇪🇺 EU + Schengen',
          '📍 Lublin / Warsaw'
        ],
        livingCost: '€400 – €700 / month',
        whyStudy: [
          'EU-recognised nursing degree',
          'Schengen visa enables EU travel & work',
          'Strong post-graduation EU job market',
          'Active Indian student community',
          'Two campus options — Lublin (affordable) or Warsaw (capital city)'
        ],
        universities: [
          {
            slug: 'wsei-university-lublin-nursing',
            name: 'WSEI University, Lublin — Nursing (Full-time)',
            location: 'Lublin, Poland',
            established: 2000,
            ranking: 'Leading private university in eastern Poland',
            tuitionFee: '€3,900 / year (€1,950 / semester)',
            totalCost: '€11,700 (3 years)',
            duration: '3 years',
            medium: 'English',
            intake: 'October (Winter) — primary intake',
            recognition: ['EU', 'WHO', 'Polish Ministry of Science & Higher Education', 'Schengen'],
            eligibility: ['12th pass with science background', 'English proficiency (IELTS preferred but flexible)'],
            accommodation: '€200 – €350 / month',
            highlights: [
              'Most affordable nursing tuition in Poland',
              'Lublin is a top student city — low cost of living',
              'EU-recognised degree with Schengen mobility',
              'Accessibility-friendly campus'
            ]
          },
          {
            slug: 'wsei-university-warsaw-nursing',
            name: 'WSEI University, Warsaw — Nursing (Full-time)',
            location: 'Warsaw, Poland',
            established: 2000,
            ranking: 'WSEI campus in Poland\'s capital city',
            tuitionFee: '€4,500 / year (€2,250 / semester)',
            totalCost: '€13,500 (3 years)',
            duration: '3 years',
            medium: 'English',
            intake: 'October (Winter) — primary intake',
            recognition: ['EU', 'WHO', 'Polish Ministry of Science & Higher Education', 'Schengen'],
            eligibility: ['12th pass with science background', 'English proficiency (IELTS preferred but flexible)'],
            accommodation: '€350 – €550 / month',
            highlights: [
              'Located in Warsaw — Poland\'s capital & largest job market',
              'EU-recognised nursing degree',
              'Schengen visa benefits',
              'Strong international student community'
            ]
          }
        ]
      },
      {
        slug: 'lithuania',
        name: 'Lithuania',
        flag: '🇱🇹',
        capital: 'Vilnius',
        currency: 'EUR',
        about: 'Lithuania — an EU & Schengen member — offers globally accredited BSc Nursing at the Lithuanian University of Health Sciences (LSMU), the country\'s leading health-sciences university with clinical training at the largest hospital in the Baltic States.',
        usp: [
          '💵 €4,300/yr',
          '🎓 4 yrs · 240 ECTS',
          '🇪🇺 EU + Schengen',
          '🏥 Baltic\'s largest hospital'
        ],
        livingCost: '€450 – €700 / month',
        whyStudy: [
          'EU-accredited nursing degree, diploma recognised across the EU',
          'Clinical training at the largest hospital in the Baltic States',
          'Multicultural community — 28%+ international students from 88+ countries',
          'Erasmus+ exchange — possibility to spend a semester abroad',
          'Mentoring, tutoring & psychological counselling support'
        ],
        universities: [
          {
            slug: 'lsmu-kaunas-nursing',
            name: 'Lithuanian University of Health Sciences (LSMU) — Kaunas',
            location: 'Kaunas, Lithuania',
            established: 1922,
            ranking: '#1 health-sciences university in Lithuania',
            tuitionFee: '€4,300 / year',
            totalCost: '€17,200 tuition (4 years) + €150 application + €250 registration (one-time, non-refundable)',
            duration: '4 years (240 ECTS)',
            medium: 'English',
            intake: 'September (Academic year starts 1 Sept · application deadline 6 July)',
            recognition: ['EU', 'WHO', 'Lithuanian Ministry of Education', 'Schengen', 'Accredited until 2028'],
            eligibility: [
              'High school / secondary education with good results in Biology & Chemistry',
              'Entrance test (Biology & Chemistry) mandatory if subjects not studied or low grades',
              'English B1 level (or equivalent)',
              'Apostille / MFA legalisation of education certificates',
              'Note: applications NOT accepted from Pakistan'
            ],
            accommodation: '€200 – €400 / month',
            highlights: [
              'BSc (Bachelor in Health Sciences) — 240 ECTS, EU-recognised',
              'Clinical training at Kaunas Clinics — the largest hospital in the Baltic States',
              'Erasmus+ exchange — study a semester abroad',
              'Apply for a Lithuanian/EU nursing licence on graduation',
              'Pathway to Master\'s programmes & EU-wide career mobility'
            ]
          }
        ]
      },
      {
        slug: 'austria',
        name: 'Austria',
        flag: '🇦🇹',
        capital: 'Vienna',
        currency: 'EUR',
        about: 'Austria offers one of the most rewarding BSc Nursing programs in the EU — almost FREE education at public universities, monthly stipends up to €1,300, guaranteed placement at €50,000/year, and easy migration pathways to Germany.',
        usp: [
          '💵 €720/sem 🆓',
          '💶 Stipend up to €1,300/mo',
          '🎓 3 yrs',
          '🎯 €50K/yr placement',
          '🇩🇪 Pathway to Germany'
        ],
        livingCost: '€700 – €1,000 / month (covered by stipend)',
        whyStudy: [
          'Almost FREE education at public universities (€720/semester only)',
          'Stipend up to €1,300/month while studying',
          'Guaranteed placement at €50,000/year after graduation',
          'No blocked amount needed',
          'No TestAS / APS / IELTS required',
          '20 hours/week part-time work allowed',
          'Easy migration pathway to Germany'
        ],
        universities: [
          {
            slug: 'austria-bsc-health-care-and-nursing',
            name: 'BSc Health Care & Nursing — Austrian Public Universities',
            location: 'Austria',
            established: null,
            ranking: 'Top-tier EU public nursing programs',
            tuitionFee: '€720 / semester (almost FREE public education)',
            totalCost: '€4,320 total (6 semesters) — offset by up to €1,300/month stipend',
            duration: '3 years (6 semesters)',
            medium: 'German (B2 Level required)',
            intake: 'Winter & Summer',
            recognition: ['EU', 'WHO', 'Austrian Ministry of Education', 'Schengen', 'Germany migration pathway'],
            eligibility: [
              '12th pass',
              'German Language B2 Level',
              'NO IELTS / TestAS / APS required',
              'NO blocked account / blocked amount needed'
            ],
            accommodation: 'Covered by stipend',
            highlights: [
              '💶 Stipend up to €1,300 / month while studying',
              '🎯 Guaranteed placement at €50,000 / year after graduation',
              '🆓 Almost FREE education — just €720 / semester at public universities',
              '🇩🇪 Easy migration pathway to Germany after graduation',
              '⏱️ 20 hours / week part-time work allowed',
              '✅ No blocked amount · No TestAS · No APS · No IELTS'
            ]
          }
        ]
      }
    ]
  },

  {
    slug: 'veterinary-medicine',
    name: 'Veterinary Medicine',
    fullName: 'Doctor of Veterinary Medicine (DVM)',
    icon: 'PawPrint',
    color: '#8B5A3C',
    tagline: 'Heal animals and build a career in one of the fastest-growing healthcare fields',
    shortDescription: 'Pursue Veterinary Medicine in Europe with hands-on clinical training and globally accepted degrees.',
    longDescription: 'Veterinary Medicine is a 5.5–6 year program that prepares students to become licensed veterinary doctors. Patrick\'s Edu Care places students at top European universities — Technical University of Moldova (UTM), University of Forestry Sofia, and Trakia University Bulgaria — offering English-medium DVM programs at highly affordable tuition. Graduates can practice globally after meeting local licensing requirements.',
    image: '/img/stock/1583337130417-3346a1be7dee.webp',
    duration: '5.5–6 years',
    averageFee: '€3,200 – €6,200 / year',
    medium: 'English',
    highlights: [
      'European DVM degree',
      'Hands-on animal clinical practice',
      'Affordable tuition',
      'Global career mobility',
      'Hostel & Indian mess support'
    ],
    seo: {
      title: 'Study Veterinary Medicine Abroad 2026 | DVM in Moldova | Patrick\'s Edu Care',
      description: 'Pursue Veterinary Medicine abroad in English-medium European universities. Affordable fees, hands-on clinical training, global recognition. Apply with Patrick\'s Edu Care.',
      keywords: 'veterinary medicine abroad, DVM in Moldova, vet science abroad, study veterinary Europe'
    },
    countries: [
      {
        slug: 'moldova',
        name: 'Moldova',
        flag: '🇲🇩',
        capital: 'Chișinău',
        currency: 'EUR / MDL',
        about: 'Moldova offers one of the most affordable Veterinary Medicine programs in Europe with English-medium teaching at the Technical University of Moldova (UTM).',
        usp: [
          '💵 €3,200/yr 💎',
          '🎓 6 yrs',
          '🇪🇺 EU degree',
          '📚 60% PCB · age ≤27'
        ],
        livingCost: '$180 – $300 / month',
        whyStudy: [
          'Affordable European degree',
          'English-medium curriculum',
          'Direct admission',
          'Hands-on clinical training'
        ],
        universities: [
          {
            slug: 'technical-university-moldova',
            name: 'Technical University of Moldova (UTM) — Veterinary Medicine',
            location: 'Chișinău, Moldova',
            established: 1964,
            ranking: '#1 Technical University in Moldova',
            tuitionFee: '€3,200 / year (+ €100 one-time admission fee)',
            totalCost: '€19,200 tuition (6 years) + €100 admission',
            duration: '6 years · 360 ECTS · Integrated Bachelor\'s + Master\'s degree',
            medium: 'English',
            intake: 'September',
            recognition: ['EU', 'Ministry of Education Moldova', 'European Higher Education Area'],
            eligibility: ['12th with PCB minimum 60%', 'Maximum age 27', 'Basic English proficiency'],
            accommodation: '$80 – $150 / month',
            highlights: [
              '🎓 Integrated 6-year program — earns both Bachelor\'s + Master\'s degree (360 ECTS)',
              '🇪🇺 EU-recognised European DVM degree at most affordable tuition',
              '🏛️ Patrick\'s Edu Care official representative',
              '💉 Modern veterinary labs',
              '🎯 One-time €100 admission fee — no hidden charges',
              '📚 Also offers: Animal Husbandry — €2,300/year Bachelor\'s (4 yrs · 240 ECTS, English)'
            ]
          }
        ]
      },
      {
        slug: 'bulgaria',
        name: 'Bulgaria',
        flag: '🇧🇬',
        capital: 'Sofia',
        currency: 'EUR / BGN',
        about: 'Bulgaria offers EU-recognised Veterinary Medicine programs with English-medium teaching, Schengen visa benefits, and a globally accepted European DVM degree.',
        usp: [
          '💵 €5,300–6,200/yr',
          '🎓 5.5 yrs',
          '🇪🇺 EU + Schengen',
          '📚 62% PCB'
        ],
        livingCost: '€250 – €400 / month',
        whyStudy: [
          'EU-recognised DVM degree',
          'Schengen visa benefits',
          'Hands-on clinical & farm training',
          'Pathway to EU veterinary practice'
        ],
        universities: [
          {
            slug: 'university-of-forestry-sofia',
            name: 'University of Forestry, Sofia',
            location: 'Sofia, Bulgaria',
            established: 1925,
            ranking: 'Leading agricultural & veterinary university in Bulgaria',
            tuitionFee: '€5,300 / year',
            totalCost: '€29,150 (5.5 years)',
            duration: '5.5 years',
            medium: 'English',
            intake: 'September',
            recognition: ['EU', 'WHO', 'Ministry of Education Bulgaria', 'Schengen'],
            eligibility: ['12th with PCB minimum 62%', 'Basic English'],
            accommodation: '€150 – €250 / month',
            highlights: ['EU DVM degree', 'Strong forestry & veterinary heritage', 'Schengen visa benefits']
          },
          {
            slug: 'trakia-university-stara-zagora',
            name: 'Trakia University, Stara Zagora',
            location: 'Stara Zagora, Bulgaria',
            established: 1995,
            ranking: 'Top veterinary medicine faculty in Bulgaria',
            tuitionFee: '€6,200 / year',
            totalCost: '€34,100 (5.5 years)',
            duration: '5.5 years',
            medium: 'English',
            intake: 'September',
            recognition: ['EU', 'WHO', 'Ministry of Education Bulgaria', 'Schengen'],
            eligibility: ['12th with PCB minimum 62%', 'Basic English'],
            accommodation: '€150 – €250 / month',
            highlights: ['Renowned vet medicine faculty', 'Modern clinical & farm facilities', 'EU + Schengen benefits']
          }
        ]
      }
    ]
  },

  {
    slug: 'dentistry',
    name: 'Dentistry',
    fullName: 'Doctor of Dental Surgery (DDS / BDS)',
    icon: 'Smile',
    color: '#4DD4AC',
    tagline: 'Build a thriving global dental career with European clinical training',
    shortDescription: 'Pursue Dentistry in WHO-recognised English-medium programs at top Georgian universities.',
    longDescription: 'Dentistry abroad offers Indian students an excellent alternative to private dental colleges in India. Patrick\'s Edu Care places students at top Georgian universities — Alte University and University of Georgia — offering English-medium DDS / Doctor of Dental Medicine programs with hands-on clinical training, modern phantom labs and hospital-attached patient rotations.',
    image: '/img/stock/1606811971618-4486d14f3f99.webp',
    duration: '5 years',
    averageFee: '$4,500 – $6,000 / year',
    medium: 'English',
    highlights: [
      'WHO & NMC recognised',
      'English-medium DDS / DDM programs',
      'Hands-on clinical training in modern phantom labs',
      'Affordable compared to private BDS in India',
      'FMGE / NExT eligible'
    ],
    seo: {
      title: 'Study Dentistry Abroad 2026 | DDS in Georgia | Alte University & University of Georgia | Patrick\'s Edu Care',
      description: 'Pursue Dentistry in Georgia at Alte University ($4,500/yr) or University of Georgia ($6,000/yr) — WHO-recognised, English-medium, 5-year DDS program. Apply with Patrick\'s Edu Care.',
      keywords: 'dentistry abroad, DDS Georgia, Alte University dentistry, University of Georgia dentistry, dental degree Georgia, BDS abroad'
    },
    countries: [
      {
        slug: 'georgia',
        name: 'Georgia',
        flag: '🇬🇪',
        capital: 'Tbilisi',
        currency: 'USD / GEL',
        about: 'Georgia is Patrick\'s Edu Care\'s top destination for Dentistry — English-medium curriculum, affordable tuition, modern phantom labs and hospital-attached clinical rotations at university-owned dental clinics.',
        usp: [
          '💵 $4,500–6,000/yr',
          '🦷 5 yrs DDS',
          '🇮🇳 NMC + WHO',
          '🧪 Phantom labs'
        ],
        livingCost: '$200 – $350 / month',
        whyStudy: [
          'WHO & NMC India recognised',
          'English-medium DDS / Doctor of Dental Medicine',
          'Hands-on practice on phantoms before patients',
          'University-owned dental clinics for clinical work',
          'Affordable vs. private BDS in India'
        ],
        universities: [
          {
            slug: 'alte-university-dentistry',
            name: 'Alte University — Dentistry (English)',
            location: 'Tbilisi, Georgia',
            established: 1992,
            ranking: 'International Medical School at Alte University',
            tuitionFee: '$4,500 / year',
            totalCost: '$22,500 (5 years)',
            duration: '5 years (Single-cycle DDS)',
            medium: 'English',
            intake: 'September & February',
            recognition: ['WHO', 'NMC India', 'Ministry of Education Georgia'],
            eligibility: ['12th with PCB', 'Basic English proficiency'],
            accommodation: '$150 – $250 / month',
            highlights: [
              'Modern phantom labs — practise procedures before treating patients',
              'University-owned dental clinic + partnerships with leading dental clinics in Tbilisi',
              'Multidisciplinary hospital training for systemic disease exposure',
              'Curriculum focused on research skills + clinical practice'
            ]
          },
          {
            slug: 'university-of-georgia-dentistry',
            name: 'University of Georgia (UG) — Doctor of Dental Medicine',
            location: 'Tbilisi, Georgia',
            established: 2004,
            ranking: 'Top 3 private university in Georgia',
            tuitionFee: '$6,000 / year',
            totalCost: '$30,000 (5 years)',
            duration: '5 years · 300 ECTS (Single-cycle DDM)',
            medium: 'English',
            intake: 'September & February',
            recognition: ['WHO', 'NMC India', 'Ministry of Education Georgia', 'European credit system'],
            eligibility: [
              'IELTS / TOEFL / Cambridge / UNIcert® / EnglishScore — B1+ in English',
              'OR Medium of Instruction = English on prior education',
              'Admission interview in Biology / Chemistry / Physics (basic)'
            ],
            accommodation: '$150 – $250 / month',
            highlights: [
              '300 ECTS · 5-year single-cycle Doctor of Dental Medicine',
              'Mentor-system practical training (≤15 students per lab/clinical group)',
              'Structured integrated evaluation in simulation + clinical setting',
              'Pathway to dental residency, Master\'s & Doctoral programs',
              'Eligible to practise in Georgia + foreign jurisdictions per local laws'
            ]
          }
        ]
      }
    ]
  },

  {
    slug: 'artificial-intelligence',
    name: 'Artificial Intelligence',
    fullName: 'BSc / MSc in Artificial Intelligence',
    icon: 'Brain',
    color: '#7B61FF',
    tagline: 'Master the technology shaping the future of every industry',
    shortDescription: 'Study Artificial Intelligence at top European universities — Bulgaria, Malta, Georgia, Slovakia & Hungary — with research-led curriculum and industry placements.',
    longDescription: 'Artificial Intelligence is one of the highest-demand fields globally. Patrick\'s Edu Care places students at top universities across Bulgaria, Malta, Georgia, Slovakia and Hungary offering BSc and MSc AI programs with hands-on labs, internships, and industry partnerships. Graduates land roles in machine learning, data science, and AI engineering across Europe and globally.',
    image: '/img/stock/1677442136019-21780ecad995.webp',
    duration: '18 months (MSc) – 4 years (BSc)',
    averageFee: '€3,000 – €7,900',
    medium: 'English',
    highlights: [
      'Highest-demand global career',
      'Research-led European curriculum',
      'Industry internships included',
      'AWS / Cisco / SAP integrated certifications (Alte)',
      'Pathway to EU tech jobs'
    ],
    seo: {
      title: 'Study Artificial Intelligence Abroad 2026 | AI Degrees in Bulgaria, Malta, Georgia, Slovakia & Hungary | Patrick\'s Edu Care',
      description: 'Pursue BSc/MSc Artificial Intelligence at top universities across Bulgaria (Varna Naval Academy, Varna TU), Malta (MCAST), Georgia (UG, Alte), Slovakia & Hungary. Apply with Patrick\'s Edu Care.',
      keywords: 'artificial intelligence abroad, AI degree Europe, MSc AI Malta MCAST, BSc AI Bulgaria, AI Georgia, AI Slovakia, AI Hungary'
    },
    countries: [
      {
        slug: 'bulgaria',
        name: 'Bulgaria',
        flag: '🇧🇬',
        capital: 'Sofia',
        currency: 'EUR / BGN',
        about: 'Bulgaria offers affordable EU-recognised AI programs at Varna — with Bachelor\'s at Varna Naval Academy and Master\'s at Varna Technical University.',
        usp: [
          '💵 €3,000–3,500/yr 💎',
          '🎓 4 yrs BSc / 2 yrs MSc',
          '🇪🇺 EU + Schengen'
        ],
        livingCost: '€250 – €400 / month',
        whyStudy: [
          'EU + Schengen recognised degree',
          'Most affordable AI tuition in the EU',
          'Coastal Black Sea campus city',
          'Strong tech industry growth'
        ],
        universities: [
          {
            slug: 'varna-naval-academy-ai',
            name: 'Varna Naval Academy — Bachelor in Artificial Intelligence',
            location: 'Varna, Bulgaria',
            established: 1881,
            ranking: 'Premier maritime & engineering academy in Bulgaria',
            tuitionFee: '€3,000 / year',
            totalCost: '€12,000 (4 years)',
            duration: '4 years (Bachelor\'s)',
            medium: 'English',
            intake: 'September',
            recognition: ['EU', 'Ministry of Education Bulgaria', 'Schengen'],
            eligibility: ['12th pass with Math', 'English proficiency (IELTS preferred)'],
            accommodation: '€150 – €250 / month',
            highlights: [
              'Most affordable AI Bachelor\'s in the EU',
              'EU + Schengen recognised',
              'Strong engineering legacy'
            ]
          },
          {
            slug: 'varna-technical-university-ai',
            name: 'Varna Technical University — Master in Artificial Intelligence',
            location: 'Varna, Bulgaria',
            established: 1962,
            ranking: 'Leading technical university in eastern Bulgaria',
            tuitionFee: '€3,500 / year',
            totalCost: '€7,000 (2 years)',
            duration: '2 years (Master\'s)',
            medium: 'English',
            intake: 'September',
            recognition: ['EU', 'Ministry of Education Bulgaria', 'Schengen'],
            eligibility: ['Bachelor\'s in a related/STEM field', 'IELTS preferred'],
            accommodation: '€150 – €250 / month',
            highlights: [
              'Affordable EU Master\'s in AI',
              'Schengen visa benefits',
              'Strong research-led curriculum'
            ]
          }
        ]
      },
      {
        slug: 'malta',
        name: 'Malta',
        flag: '🇲🇹',
        capital: 'Valletta',
        currency: 'EUR',
        about: 'Malta — an English-speaking EU island nation — offers a globally recognised Master of Science in Artificial Intelligence Technologies and Applications at MCAST, the country\'s leading public vocational college.',
        usp: [
          '💵 €7,900 total (MSc)',
          '🎓 18 months · MQF L7',
          '🇬🇧 English country'
        ],
        livingCost: '€600 – €900 / month',
        whyStudy: [
          'English-speaking EU country',
          'Globally recognised MQF Level 7 Master\'s',
          'Schengen visa benefits',
          'Strong EU tech career pathway'
        ],
        universities: [
          {
            slug: 'mcast-malta-msc-ai',
            name: 'MCAST — Master of Science in AI Technologies & Applications',
            location: 'Paola, Malta',
            established: 2001,
            ranking: 'Malta\'s leading public vocational college',
            tuitionFee: '€7,900 total tuition',
            totalCost: '€7,900 tuition + €1,000 admin + €150 visa',
            duration: '18 months (MQF Level 7 Master\'s)',
            medium: 'English',
            intake: 'October & February',
            recognition: ['MQF Level 7', 'EU', 'Schengen'],
            eligibility: ['A relevant degree in a science / technology field', 'MQRIC of degree equivalent at MQF Level 6'],
            accommodation: '€350 – €550 / month',
            highlights: [
              'MQF Level 7 Master\'s — 18 months',
              'Tuition €7,900 · Admin €1,000 · Visa €150',
              'English-speaking EU island nation',
              'Globally recognised qualification'
            ]
          }
        ]
      },
      {
        slug: 'georgia',
        name: 'Georgia',
        flag: '🇬🇪',
        capital: 'Tbilisi',
        currency: 'USD / GEL',
        about: 'Georgia offers internationally recognised AI & Data Analytics programs at top private universities — University of Georgia and Alte University — with English-medium teaching and industry certifications integrated.',
        usp: [
          '💵 $3,950–5,500/yr',
          '🎓 4 yrs',
          '🏆 AWS / Cisco / SAP certs'
        ],
        livingCost: '$200 – $350 / month',
        whyStudy: [
          'Affordable English-medium AI Bachelor\'s',
          'Integrated AWS / Cisco / SAP certifications (Alte)',
          'Strong industry partnerships',
          'Direct admission, no entrance test'
        ],
        universities: [
          {
            slug: 'university-of-georgia-ai',
            name: 'University of Georgia (UG) — BSc Artificial Intelligence (Bachelor of Informatics)',
            location: 'Tbilisi, Georgia',
            established: 2004,
            ranking: 'Top 3 private university in Georgia',
            tuitionFee: '$4,000 / year',
            totalCost: '$16,000 (4 years)',
            duration: '4 years · 240 ECTS',
            medium: 'English',
            intake: 'September & February',
            recognition: ['Ministry of Education Georgia', 'European credit system'],
            eligibility: [
              'High-school certificate or equivalent',
              'English B2 — IELTS 5.5 / TOEFL iBT 72 / PTE General B2 / FCE B2 / CPE or CAE pass',
              'Or UG-administered English exam (50%+ pass)',
              'UG-administered Math exam (min 35% for foreign students)'
            ],
            accommodation: '$150 – $250 / month',
            highlights: [
              '🤖 Core AI curriculum: Machine Learning · NLP · Computer Vision · Reinforcement Learning · Generative AI',
              '💻 Strong programming foundation in Python, Java, C++ + Linux OS',
              '☁️ Electives: MLOps, Docker for AI, Big Data with Hadoop, IoT & AI, MongoDB, Blockchain',
              '⚖️ Dedicated course on AI Regulation, Ethics & Philosophy',
              '🎓 Bachelor of Informatics (240 ECTS) — pathway to MSc in AI, Data Science, Software Engineering'
            ]
          },
          {
            slug: 'caucasus-university-cs-ai',
            name: 'Caucasus University — BSc Computer Science & AI (Caucasus School of Technology)',
            location: 'Tbilisi, Georgia',
            established: 1998,
            ranking: 'Caucasus School of Technology (CST)',
            tuitionFee: '$5,500 / year',
            totalCost: '$22,000 (4 years)',
            duration: '4 years · 240 ECTS',
            medium: 'English',
            intake: 'Fall (deadline 20 May) & Spring (deadline 20 October)',
            recognition: ['Ministry of Education, Science & Youth of Georgia', 'EU credit system'],
            eligibility: [
              'Secondary education completed',
              'English B2 — IELTS 6.0 or TOEFL 78',
              'Recorded Video Interview',
              'CV/Resume + 2 Photos + Notarised Passport copy + Notarised HS certificate + Online Registration Form'
            ],
            accommodation: '$150 – $250 / month',
            highlights: [
              '🧠 Strong AI specialisation — ML, Data Science, Neural Networks, Big Data, NLP',
              '🚀 Partnership with Startup Accelerator C10 — students join real startup teams & pitches',
              '🏆 Hackathons, programming contests, student conferences & field trips',
              '⚖️ Ethics-focused curriculum — social responsibility in tech',
              '🤖 Hands-on AI solutions development with interdisciplinary approach'
            ]
          },
          {
            slug: 'alte-university-ai',
            name: 'Alte University — BSc in Artificial Intelligence & Data Analytics (English)',
            location: 'Tbilisi, Georgia',
            established: 1992,
            ranking: 'Information Technology School at Alte University',
            tuitionFee: '$3,950 / year',
            totalCost: '$15,800 (4 years)',
            duration: '4 years (Bachelor\'s)',
            medium: 'English',
            intake: 'Spring & Fall',
            recognition: ['Newly accredited — open for international students', 'Ministry of Education Georgia', 'European credit system'],
            eligibility: [
              'Same admission criteria as Computer Science programs',
              'English proficiency — B2 level (if required)',
              'Mathematics — pass an online math test'
            ],
            accommodation: '$150 – $250 / month',
            highlights: [
              'Recently accredited — applications now open for international students',
              'Two tracks — Artificial Intelligence OR Data Analytics',
              'Integrated AWS, Cisco & SAP Academy certifications',
              'Innovation & Entrepreneurship Center — startup support',
              'Practice-oriented, project-based learning with industry internships',
              'Spring & Fall intakes — flexible start dates'
            ]
          }
        ]
      },
      {
        slug: 'slovakia',
        name: 'Slovakia',
        flag: '🇸🇰',
        capital: 'Bratislava',
        currency: 'EUR',
        about: 'Slovakia is an emerging European tech hub offering affordable AI and computer science programs in English.',
        usp: [
          '💵 €5,000/yr',
          '🎓 3 yrs BSc / 2 yrs MSc',
          '🇪🇺 EU credits'
        ],
        livingCost: '€400 – €600 / month',
        whyStudy: [
          'EU degree at low cost',
          'Strong tech industry presence',
          'English-medium AI programs',
          'Schengen mobility'
        ],
        universities: [
          {
            slug: 'comenius-university-ai',
            name: 'Comenius University',
            location: 'Bratislava, Slovakia',
            established: 1919,
            ranking: '#1 University in Slovakia',
            tuitionFee: '€5,000 / year',
            totalCost: '€15,000 (3 years BSc)',
            duration: '3 years BSc / 2 years MSc',
            medium: 'English',
            intake: 'September',
            recognition: ['EU', 'Ministry of Education Slovakia', 'European Higher Education Area'],
            eligibility: ['12th with Math/Science 60%+', 'IELTS 6.0 or equivalent'],
            accommodation: '€200 – €350 / month',
            highlights: ['Top-ranked university in Slovakia', 'Research labs in ML & NLP', 'Industry partnerships']
          }
        ]
      },
      {
        slug: 'hungary',
        name: 'Hungary',
        flag: '🇭🇺',
        capital: 'Budapest',
        currency: 'EUR / HUF',
        about: 'Hungary offers prestigious EU AI programs at affordable tuition, with Budapest as a major European tech hub.',
        usp: [
          '💵 €6,000/yr',
          '🎓 3 yrs BSc / 2 yrs MSc',
          '🎓 Stipendium Hungaricum'
        ],
        livingCost: '€450 – €700 / month',
        whyStudy: [
          'Stipendium Hungaricum scholarships',
          'EU tech industry access',
          'English-medium AI programs',
          'Affordable cost of living'
        ],
        universities: [
          {
            slug: 'eotvos-lorand-university',
            name: 'Eötvös Loránd University (ELTE)',
            location: 'Budapest, Hungary',
            established: 1635,
            ranking: 'Top 3 in Hungary',
            tuitionFee: '€6,000 / year',
            totalCost: '€18,000 (3 years BSc)',
            duration: '3 years BSc / 2 years MSc',
            medium: 'English',
            intake: 'September',
            recognition: ['EU', 'European Higher Education Area'],
            eligibility: ['12th with Math 60%+', 'IELTS 6.0'],
            accommodation: '€250 – €400 / month',
            highlights: ['Historic European university', 'Strong AI & data science labs', 'Scholarship opportunities']
          }
        ]
      }
    ]
  },

  {
    slug: 'cybersecurity',
    name: 'Cybersecurity',
    fullName: 'BSc / MSc in Cybersecurity',
    icon: 'Shield',
    color: '#1A2B3C',
    tagline: 'Become a defender of the digital world with EU-grade cybersecurity training',
    shortDescription: 'Study Cybersecurity at top universities across Georgia, Bulgaria & Malta — join one of the most in-demand global tech careers.',
    longDescription: 'Cybersecurity professionals are in critical global demand. Patrick\'s Edu Care places students at top universities offering BSc and MSc Cybersecurity programs with hands-on labs, ethical hacking modules, and EU-standard certifications. Bulgaria offers the most affordable EU pathway, Malta gives an English-speaking EU experience and Georgia is hands-on and affordable.',
    image: '/img/stock/1550751827-4bd374c3f58b.webp',
    duration: '3–4 years (BSc) · 2 years (MSc)',
    averageFee: '€3,000 – €19,500',
    medium: 'English',
    highlights: [
      'Highest demand globally',
      'EU-aligned curriculum',
      'Hands-on ethical hacking & penetration testing labs',
      'Bachelor + Master tracks available',
      'Post-study work visa eligible (EU)'
    ],
    seo: {
      title: 'Study Cybersecurity Abroad 2026 | BSc/MSc in Georgia, Bulgaria, Malta, Slovakia & Hungary | Patrick\'s Edu Care',
      description: 'Pursue BSc/MSc Cybersecurity at top universities across Georgia (Caucasus, UG), Bulgaria (Varna Naval Academy, Varna TU), Malta (MCAST), Slovakia (Comenius) & Hungary (ELTE). Apply with Patrick\'s Edu Care.',
      keywords: 'cybersecurity abroad, BSc cybersecurity, MSc cybersecurity, ethical hacking degree, cybersecurity Bulgaria Varna, cybersecurity MCAST Malta, cybersecurity UG Georgia'
    },
    countries: [
      {
        slug: 'georgia',
        name: 'Georgia',
        flag: '🇬🇪',
        capital: 'Tbilisi',
        currency: 'USD / GEL',
        about: 'Georgia offers internationally recognised Cybersecurity Bachelor\'s programs in English at Caucasus University — affordable tuition, hands-on labs, and a thriving tech ecosystem with strong startup partnerships.',
        usp: [
          '💵 $5,000–5,500/yr',
          '🎓 4 yrs BSc / 2 yrs MSc',
          '🛡️ Ethical hacking labs'
        ],
        livingCost: '$200 – $350 / month',
        whyStudy: [
          'English-medium BSc Cybersecurity',
          'Affordable tuition vs. EU options',
          'Strong startup & hackathon culture',
          'Ethical hacking & forensic investigation labs'
        ],
        universities: [
          {
            slug: 'caucasus-university-cybersecurity',
            name: 'Caucasus University — BSc Cybersecurity (Caucasus School of Technology)',
            location: 'Tbilisi, Georgia',
            established: 1998,
            ranking: 'Caucasus School of Technology (CST)',
            tuitionFee: '$5,500 / year',
            totalCost: '$22,000 (4 years)',
            duration: '4 years · 240 ECTS',
            medium: 'English',
            intake: 'Fall (deadline 20 May) & Spring (deadline 20 October)',
            recognition: ['Ministry of Education, Science & Youth of Georgia', 'EU credit system'],
            eligibility: [
              'Secondary education completed',
              'English B2 — IELTS 6.0 or TOEFL 78',
              'Recorded Video Interview',
              'CV/Resume + 2 Photos + Notarised Passport copy + Notarised HS certificate + Online Registration Form'
            ],
            accommodation: '$150 – $250 / month',
            highlights: [
              '🛡️ Core curriculum: Ethical Hacking · Cryptography · Hacking & Forensic Investigation · Intrusion Detection & Prevention · Cyber Security Risk Mgmt',
              '🧠 Strong foundation in Math · Programming · Algorithms & Data Structures',
              '🎯 Electives: Web Technologies · Software Engineering · Programming Languages · IT Project Mgmt',
              '🚀 Innovation & Entrepreneurship Center partnership — startup pitches & accelerator',
              '🏆 Hackathons, programming contests, student conferences, field trips'
            ]
          },
          {
            slug: 'university-of-georgia-cybersecurity',
            name: 'University of Georgia (UG) — BSc & MSc Cybersecurity Engineering',
            location: 'Tbilisi, Georgia',
            established: 2004,
            ranking: 'Top 3 private university in Georgia',
            tuitionFee: '$5,000 / year (Bachelor\'s & Master\'s)',
            totalCost: '$20,000 for 4-year BSc · $10,000 for 2-year MSc',
            duration: '4 years BSc (240 ECTS) · 2 years MSc (120 ECTS)',
            medium: 'English',
            intake: 'September & February',
            recognition: ['Ministry of Education Georgia', 'European credit system'],
            eligibility: [
              'BSc: High-school certificate (foreign students do not need Unified National Exams)',
              'MSc: Bachelor\'s degree in IT / Computer Science / related field',
              'English B2 — IELTS 5.5 / TOEFL iBT 72 / PTE General B2 / FCE B2 / CPE or CAE pass',
              'Or UG-administered English exam (50%+ pass)',
              'UG-administered Math exam (min 20% for foreign students)'
            ],
            accommodation: '$150 – $250 / month',
            highlights: [
              '🎓 BSc + MSc tracks available at same $5,000/yr tuition',
              '🛡️ Core curriculum: Ethical Hacking, Penetration Testing, Cryptography, Incident Response, Forensics, SIEM, Red Teaming, SOC',
              '☁️ Electives: AWS / Azure cloud security, Container Security, Blockchain, Hardware Security (Arduino)',
              '🏛️ Approved & accredited by Georgia\'s Ministry of Education'
            ]
          }
        ]
      },
      {
        slug: 'bulgaria',
        name: 'Bulgaria',
        flag: '🇧🇬',
        capital: 'Sofia',
        currency: 'EUR / BGN',
        about: 'Bulgaria offers EU-recognised Cybersecurity programs at unbeatable prices — Varna Naval Academy for Bachelor\'s and Varna Technical University for Master\'s — with Schengen visa benefits and EU mobility.',
        usp: [
          '💵 €3,000–3,500/yr 💎',
          '🎓 4 yrs BSc / 2 yrs MSc',
          '🇪🇺 EU + Schengen'
        ],
        livingCost: '€250 – €400 / month',
        whyStudy: [
          'Most affordable Cybersecurity in the EU',
          'Schengen visa + EU mobility',
          'Coastal Black Sea student city',
          'Strong engineering & maritime cyber heritage'
        ],
        universities: [
          {
            slug: 'varna-naval-academy-cybersecurity',
            name: 'Varna Naval Academy — Bachelor in Cybersecurity',
            location: 'Varna, Bulgaria',
            established: 1881,
            ranking: 'Premier maritime & engineering academy in Bulgaria',
            tuitionFee: '€3,000 / year',
            totalCost: '€12,000 (4 years)',
            duration: '4 years (Bachelor\'s)',
            medium: 'English',
            intake: 'September',
            recognition: ['EU', 'Ministry of Education Bulgaria', 'Schengen'],
            eligibility: ['12th pass with Math/Computing', 'English proficiency (IELTS preferred)'],
            accommodation: '€150 – €250 / month',
            highlights: [
              'Most affordable Cybersecurity Bachelor\'s in the EU',
              'EU + Schengen recognised',
              'Strong engineering & cyber-defence legacy'
            ]
          },
          {
            slug: 'varna-technical-university-cybersecurity',
            name: 'Varna Technical University — Master in Cybersecurity',
            location: 'Varna, Bulgaria',
            established: 1962,
            ranking: 'Leading technical university in eastern Bulgaria',
            tuitionFee: '€3,500 / year',
            totalCost: '€7,000 (2 years)',
            duration: '2 years (Master\'s)',
            medium: 'English',
            intake: 'September',
            recognition: ['EU', 'Ministry of Education Bulgaria', 'Schengen'],
            eligibility: ['Bachelor\'s in IT / Computer Science / related STEM field', 'IELTS preferred'],
            accommodation: '€150 – €250 / month',
            highlights: [
              'Most affordable EU Master\'s in Cybersecurity',
              'Schengen visa benefits',
              'Strong research-led curriculum'
            ]
          }
        ]
      },
      {
        slug: 'malta',
        name: 'Malta',
        flag: '🇲🇹',
        capital: 'Valletta',
        currency: 'EUR',
        about: 'Malta — an English-speaking EU island nation — offers a globally recognised BSc (Hons) in Cybersecurity at MCAST, the country\'s leading public vocational college, with strong UK & EU career pathways.',
        usp: [
          '💵 €19,500 · €6,500 scholarship*',
          '🎓 3 yrs · MQF L6 Hons',
          '🇬🇧 English country'
        ],
        livingCost: '€600 – €900 / month',
        whyStudy: [
          'English-speaking EU country',
          'BSc (Hons) — MQF Level 6 degree',
          'Schengen visa benefits + EU career mobility',
          '€6,500 scholarship available*'
        ],
        universities: [
          {
            slug: 'mcast-malta-cybersecurity',
            name: 'MCAST — Bachelor of Science (Honours) in Cybersecurity',
            location: 'Paola, Malta',
            established: 2001,
            ranking: 'Malta\'s leading public vocational college',
            tuitionFee: '€19,500 total tuition · €6,500 scholarship available*',
            totalCost: '€19,500 tuition + €1,000 admin + €150 visa appointment',
            duration: '3 years · 180 ECTS · MQF Level 6 (Bachelor\'s Honours)',
            medium: 'English',
            intake: 'September & February',
            recognition: ['MQF Level 6', 'EU', 'Schengen'],
            eligibility: [
              'Grade 12 pass with Computing & Mathematics (or Physics)',
              '60% in English from Grade 12 OR MOI from last qualification',
              'Health screening + Police clearance certificate'
            ],
            accommodation: '€350 – €550 / month',
            highlights: [
              '🏆 BSc (Hons) — MQF Level 6 globally recognised Honours degree',
              '💶 Tuition €19,500 · scholarship up to €6,500* available',
              '🇲🇹 English-speaking EU island nation',
              '🛂 Schengen visa + UK / EU career pathways',
              '💼 Admin €1,000 · Visa appointment €150 — transparent up-front'
            ]
          }
        ]
      }
    ]
  },

  {
    slug: 'bba',
    name: 'BBA',
    fullName: 'Bachelor of Business Administration',
    icon: 'Briefcase',
    color: '#2B5B8A',
    tagline: 'Build a global business career with an international BBA degree',
    shortDescription: 'Pursue BBA at top European universities with industry exposure, internships and global career pathways.',
    longDescription: 'BBA abroad gives Indian students an international business foundation with English-medium curriculum, real-world projects, and internships. Patrick\'s Edu Care places students at top universities in Georgia, Moldova, and Hungary with strong industry partnerships and post-study work opportunities.',
    image: '/img/stock/1454165804606-c3d57bc86b40.webp',
    duration: '3–4 years',
    averageFee: '$3,500 – €6,000 / year',
    medium: 'English',
    highlights: [
      'Internationally recognized degree',
      'Industry internships',
      'Multinational student cohort',
      'Pathway to global MBA',
      'Affordable European tuition'
    ],
    seo: {
      title: 'Study BBA Abroad 2026 | International BBA Europe | Patrick\'s Edu Care',
      description: 'Pursue BBA at top European universities in Georgia, Moldova & Hungary. Industry internships, English-medium, affordable tuition. Apply with Patrick\'s Edu Care.',
      keywords: 'BBA abroad, BBA Georgia, BBA Moldova, BBA Hungary, international BBA, study business abroad'
    },
    countries: [
      {
        slug: 'georgia',
        name: 'Georgia',
        flag: '🇬🇪',
        capital: 'Tbilisi',
        currency: 'USD / GEL',
        about: 'Georgia offers internationally recognized BBA programs at affordable tuition with strong industry exposure.',
        usp: [
          '💵 $3,500–5,500/yr',
          '🎓 3 yrs',
          '🇫🇷 Optional Montpellier dual-diploma',
          '🏆 95% job rate (CU)'
        ],
        livingCost: '$200 – $350 / month',
        whyStudy: [
          'EU credit system',
          'English-medium business education',
          'Affordable tuition & living',
          'Internship opportunities'
        ],
        universities: [
          {
            slug: 'caucasus-university-bba',
            name: 'Caucasus University — Caucasus School of Business (BBA)',
            location: 'Tbilisi, Georgia',
            established: 1998,
            ranking: 'Top Business School in Georgia (Eduniversal — 5 consecutive years)',
            tuitionFee: '$5,500 / year',
            totalCost: '$16,500 (3 years)',
            duration: '3 years · 180 ECTS',
            medium: 'English',
            intake: 'Fall (deadline 20 May) & Spring (deadline 20 October)',
            recognition: ['Ministry of Education, Science, Culture & Sport of Georgia', 'AACSB · ACCA · GEM · NIBES · IAUP memberships', 'EU credit system'],
            eligibility: [
              'Secondary education completed',
              'English B2 — IELTS 6.0 or TOEFL 78',
              'Recorded Video Interview',
              'CV/Resume + 2 Photos + Notarised Passport copy + Notarised HS certificate + Online Registration Form'
            ],
            accommodation: '$150 – $250 / month',
            highlights: [
              '🏆 95% of graduates employed within 1 year',
              '📚 4 specialisations: Finance · Management · Marketing · Accounting',
              '🌍 Western-values curriculum aligned with top foreign business schools',
              '🤝 AACSB, ACCA, GEM, NIBES, IAUP member institution',
              '🌐 Exchange-program opportunities to study abroad',
              '🇫🇷🇩🇪🇪🇸🇹🇷 Elective foreign languages: French · German · Spanish · Turkish',
              'Final project: Business Plan Development'
            ]
          },
          {
            slug: 'alte-university-bba',
            name: 'Alte University — Bachelor of Business Administration (Dual-Diploma option with University of Montpellier, France)',
            location: 'Tbilisi, Georgia',
            established: 1992,
            ranking: 'Business School at Alte University',
            tuitionFee: '$3,500 / year (Alte) · Optional final year in Montpellier €10,500 (partner rate vs. standard €13,000)',
            totalCost: '$10,500 (3 years at Alte) · or $7,000 + €10,500 (2 yrs Alte + 1 yr Montpellier dual diploma)',
            duration: '3 years (Bachelor\'s)',
            medium: 'English',
            intake: 'Fall intake',
            recognition: ['Ministry of Education Georgia', 'European credit system', 'Final accreditation expected June 2026'],
            eligibility: ['12th pass', 'Basic English proficiency'],
            accommodation: '$150 – $250 / month',
            highlights: [
              '🇫🇷 Dual-diploma option — final year at the University of Montpellier, France (optional, not mandatory)',
              'Two diplomas — one from Alte University & one from University of Montpellier',
              'Special partner tuition for Montpellier final year — €10,500 (vs. standard €13,000)',
              'Currently in accreditation — final accreditation expected June 2026',
              'Partners can reserve seats & submit preliminary student documents for the upcoming intake',
              'Full program also available 100% at Alte (Georgia) without Montpellier'
            ]
          },
          {
            slug: 'university-of-georgia-bba',
            name: 'University of Georgia (UG) — Bachelor of Business Administration (3 years, English)',
            location: 'Tbilisi, Georgia',
            established: 2004,
            ranking: 'Top 3 private university in Georgia',
            tuitionFee: '$4,000 / year',
            totalCost: '$12,000 (3 years)',
            duration: '3 years · 180 ECTS',
            medium: 'English',
            intake: 'September & February',
            recognition: ['Ministry of Education Georgia', 'European credit system'],
            eligibility: [
              'High-school certificate (foreign students do not need Unified National Exams)',
              'English B1 — IELTS 4.5 / TOEFL iBT 70 / PTE General B1 / FCE B / CPE or CAE pass',
              'Or UG-administered B1 English test (70%+ pass)'
            ],
            accommodation: '$150 – $250 / month',
            highlights: [
              '📚 4 concentration tracks: Finance · Marketing · Management · Accounting',
              '🎓 Bachelor of Business Administration — 180 ECTS in just 3 years',
              '🌍 Globally portable EU-credit-system degree',
              '🏛️ Approved by Georgia\'s Ministry of Education',
              '💼 Pathway to international middle-management roles & MBA'
            ]
          }
        ]
      },
      {
        slug: 'moldova',
        name: 'Moldova',
        flag: '🇲🇩',
        capital: 'Chișinău',
        currency: 'EUR / MDL',
        about: 'Moldova offers the most affordable European BBA programs — €2,500/year tuition with EU credit transferability and direct admission.',
        usp: [
          '💵 €2,500/yr 🌟',
          '🎓 3 yrs',
          '🇪🇺 EU degree',
          '📚 60% · age ≤27'
        ],
        livingCost: '$180 – $300 / month',
        whyStudy: [
          'Most affordable European BBA (€2,500 / year)',
          'EU credit transferability',
          'English-medium teaching',
          'Direct admission, no entrance exam'
        ],
        universities: [
          {
            slug: 'asem-moldova-bba',
            name: 'ASEM — Academy of Economic Studies of Moldova (Business & Administration)',
            location: 'Chișinău, Moldova',
            established: 1991,
            ranking: '#1 Business & Economics University in Moldova',
            tuitionFee: '€2,500 / year',
            totalCost: '€7,500 (3 years)',
            duration: '3 years',
            medium: 'English',
            intake: 'September',
            recognition: ['EU', 'European Higher Education Area', 'Ministry of Education Moldova'],
            eligibility: ['12th pass with minimum 60%', 'Maximum age 27', 'Basic English proficiency'],
            accommodation: '$80 – $150 / month',
            highlights: [
              '🇪🇺 Most affordable European BBA — €2,500 / year',
              '🏆 #1 Business & Economics University in Moldova',
              '🎓 EU credit-system globally portable degree',
              '📚 Related English-medium tracks: Hotel/Tourism · World Economy & International Relations · Finance & Banking'
            ]
          },
          {
            slug: 'technical-university-moldova-bba',
            name: 'Technical University of Moldova (UTM) — Business Administration',
            location: 'Chișinău, Moldova',
            established: 1964,
            ranking: '#1 Technical University in Moldova',
            tuitionFee: '€2,500 / year (+ €100 one-time admission fee)',
            totalCost: '€7,500 (3 years · 180 ECTS)',
            duration: '3 years · 180 ECTS',
            medium: 'English',
            intake: 'September',
            recognition: ['EU', 'European Higher Education Area', 'Ministry of Education Moldova'],
            eligibility: ['12th pass with minimum 60%', 'Maximum age 27', 'Basic English proficiency'],
            accommodation: '$80 – $150 / month',
            highlights: [
              '🇪🇺 EU-recognised BBA — €2,500/year',
              '🏛️ Patrick\'s Edu Care official representative',
              '💼 Strong tech-business curriculum',
              '🎯 One-time €100 admission fee — no other hidden charges'
            ]
          }
        ]
      }
    ]
  },

  {
    slug: 'mba',
    name: 'MBA',
    fullName: 'Master of Business Administration',
    icon: 'TrendingUp',
    color: '#FF9F1C',
    tagline: 'Accelerate your career with a globally respected MBA degree',
    shortDescription: 'Pursue MBA at accredited European universities with industry projects, internships and global career mobility.',
    longDescription: 'An MBA abroad opens doors to senior management roles, entrepreneurship and global career mobility. Patrick\'s Edu Care places students at accredited European universities offering 1-2 year English-medium MBA programs with industry projects, networking events and post-study work visas.',
    image: '/img/stock/1542744173-8e7e53415bb0.webp',
    duration: '1–2 years',
    averageFee: '$4,500 – €10,000 / year',
    medium: 'English',
    highlights: [
      'AACSB / EU accredited programs',
      'Industry capstone projects',
      'Post-study work visa eligible',
      'Strong alumni network',
      'Specializations available'
    ],
    seo: {
      title: 'Study MBA Abroad 2026 | International MBA Europe | Patrick\'s Edu Care',
      description: 'Pursue MBA at accredited European universities. Industry projects, post-study work visa, affordable tuition. Apply with Patrick\'s Edu Care.',
      keywords: 'MBA abroad, MBA Georgia, MBA Hungary, MBA Moldova, international MBA, study MBA Europe'
    },
    countries: [
      {
        slug: 'georgia',
        name: 'Georgia',
        flag: '🇬🇪',
        capital: 'Tbilisi',
        currency: 'USD / GEL',
        about: 'Georgia offers internationally recognized MBA programs at affordable tuition with strong industry projects.',
        usp: [
          '💵 $5,000/yr · $10K total ⭐',
          '🎓 2–5 yrs flexible',
          '🏆 CEEMAN accredited',
          '🥇 #1 in Georgia'
        ],
        livingCost: '$200 – $350 / month',
        whyStudy: [
          'Affordable international MBA',
          'EU credit system',
          'Industry capstone projects',
          'Post-study work eligibility'
        ],
        universities: [
          {
            slug: 'caucasus-university-mba',
            name: 'Caucasus University — MBA (Caucasus School of Business)',
            location: 'Tbilisi, Georgia',
            established: 1998,
            ranking: '🏆 #7 in Eurasia & Middle East (#1 in Georgia) — best-masters.com · Listed in Eduniversal Excellent Business School ranking',
            tuitionFee: '$5,000 / year — total program fee $10,000 (split into 2 annual installments, no need to pay full upfront)',
            totalCost: '$10,000 total (paid as $5,000/year over 2 years · 120 ECTS)',
            duration: 'Full-time: 2 years · Flexible: 3 to 5 years (120 ECTS)',
            medium: 'English',
            intake: 'Fall (deadline 20 May) & Spring (deadline 20 October)',
            recognition: [
              'Ministry of Education, Science, Culture & Sport of Georgia',
              'CEEMAN international accreditation',
              'AACSB · GEM · ACCA · NIBES · IAUP memberships',
              'EU credit system'
            ],
            eligibility: [
              'Undergraduate degree',
              'English B2 — IELTS 6.0 or TOEFL 78',
              'Minimum 2 years of full-time work experience',
              'Recorded Video Interview',
              'Motivation letter + 2 recommendation letters + CV + 2 photos + Notarised Passport/Transcript/Diploma copies'
            ],
            accommodation: '$150 – $250 / month',
            highlights: [
              '🏆 Ranked #7 in Eurasia & Middle East — #1 in Georgia (best-masters.com)',
              '🌍 CEEMAN internationally accredited · AACSB / ACCA / GEM / NIBES / IAUP member',
              '📚 3 specialisations: Finance · Management · Marketing',
              '⏱️ Flexible study mode — finish in 2 years (full-time) or stretch up to 5 years',
              '🎯 Total program fee just $10,000 — pay only $5,000/year (no need to pay full course fee upfront)',
              '📝 Final project: Master\'s Thesis'
            ]
          },
          {
            slug: 'university-of-georgia-mba',
            name: 'University of Georgia (UG) — Master of Business Administration',
            location: 'Tbilisi, Georgia',
            established: 2004,
            ranking: 'Top 3 private university in Georgia',
            tuitionFee: '$4,500 / year',
            totalCost: '$9,000 (2 years · 120 ECTS)',
            duration: '2 years · 120 ECTS',
            medium: 'English',
            intake: 'September & February',
            recognition: ['Ministry of Education Georgia', 'European credit system'],
            eligibility: [
              'Bachelor\'s degree (any field)',
              'English B2 — IELTS 6.5 / TOEFL iBT 80 / PTE General B2 / FCE B',
              'Or UG-administered B2 English test (70%+ pass)'
            ],
            accommodation: '$150 – $250 / month',
            highlights: [
              '🎓 Master of Business Administration — 120 ECTS',
              '📚 Core areas: Managerial Economics, Strategic Mgmt, Marketing Mgmt, Operations, Statistics, Financial & Managerial Accounting',
              '🎯 Electives: International Business, Investment Trading, Decision Modeling (Excel), Public Relations, HR & Project Mgmt',
              '📝 Capstone: Master\'s Thesis in Business Administration (30 ECTS)',
              '🌍 EU-credit-system globally portable MBA'
            ]
          }
        ]
      },
      {
        slug: 'moldova',
        name: 'Moldova',
        flag: '🇲🇩',
        capital: 'Chișinău',
        currency: 'EUR / MDL',
        about: 'Moldova offers the most affordable European MBA programs in English — €2,500/year tuition with EU credit transferability and direct admission.',
        usp: [
          '💵 €2,500/yr · €5K total 🌟',
          '🎓 2 yrs',
          '🇪🇺 EU degree',
          '🌾 Agri-MBA available'
        ],
        livingCost: '$180 – $300 / month',
        whyStudy: [
          'Most affordable European MBA (€2,500 / year)',
          'EU credit system',
          'English-medium',
          'Direct admission, no entrance exam'
        ],
        universities: [
          {
            slug: 'asem-moldova-mba',
            name: 'ASEM — Academy of Economic Studies of Moldova (MBA)',
            location: 'Chișinău, Moldova',
            established: 1991,
            ranking: '#1 Business & Economics University in Moldova',
            tuitionFee: '€2,500 / year',
            totalCost: '€5,000 (2 years)',
            duration: '2 years',
            medium: 'English',
            intake: 'September',
            recognition: ['EU', 'European Higher Education Area', 'Ministry of Education Moldova'],
            eligibility: ['Bachelor\'s degree (any field) with minimum 60%', 'Maximum age 27', 'Basic English proficiency'],
            accommodation: '$80 – $150 / month',
            highlights: [
              '🇪🇺 Most affordable EU MBA — just €2,500/year',
              '🏆 #1 Business & Economics University in Moldova',
              '🎓 EU credit-system globally portable degree',
              '📚 Strong specialisations in International Business, Finance & Management'
            ]
          },
          {
            slug: 'technical-university-moldova-mba',
            name: 'Technical University of Moldova (UTM) — MBA',
            location: 'Chișinău, Moldova',
            established: 1964,
            ranking: '#1 Technical University in Moldova',
            tuitionFee: '€2,500 / year',
            totalCost: '€5,000 (2 years)',
            duration: '2 years',
            medium: 'English',
            intake: 'September',
            recognition: ['EU', 'European Higher Education Area', 'Ministry of Education Moldova'],
            eligibility: ['Bachelor\'s degree (any field) with minimum 60%', 'Maximum age 27', 'Basic English proficiency'],
            accommodation: '$80 – $150 / month',
            highlights: [
              '🇪🇺 Most affordable EU MBA — just €2,500/year',
              '🏛️ Patrick\'s Edu Care official representative',
              '💼 Strong tech-business curriculum',
              '🎓 EU credit-system globally portable degree'
            ]
          },
          {
            slug: 'technical-university-moldova-agri-mba',
            name: 'Technical University of Moldova (UTM) — Agri-MBA',
            location: 'Chișinău, Moldova',
            established: 1964,
            ranking: 'Unique specialised MBA in Moldova',
            tuitionFee: '€2,500 / year',
            totalCost: '€5,000 (2 years)',
            duration: '2 years',
            medium: 'English',
            intake: 'September',
            recognition: ['EU', 'European Higher Education Area', 'Ministry of Education Moldova'],
            eligibility: ['Bachelor\'s degree with minimum 60% (any field, preferably with Agri / Business background)', 'Maximum age 27', 'Basic English proficiency'],
            accommodation: '$80 – $150 / month',
            highlights: [
              '🌾 Unique Agri-MBA — only one in Moldova',
              '🇪🇺 €2,500/year EU MBA — globally portable',
              '🏛️ Patrick\'s Edu Care official representative',
              '💡 Specialised curriculum: agribusiness, agri-finance, supply-chain & rural entrepreneurship'
            ]
          }
        ]
      }
    ]
  }
];

// Helpers
export const getProgramBySlug = (slug) => programs.find((p) => p.slug === slug);

export const getCountryByProgramAndSlug = (programSlug, countrySlug) => {
  const program = getProgramBySlug(programSlug);
  if (!program) return null;
  return program.countries.find((c) => c.slug === countrySlug);
};

export const getAllProgramSlugs = () => programs.map((p) => p.slug);
